import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { updateClinicalSettings } from '@/core/app/slices/user/userApis'
import { setAlert } from '@/core/app/slices/alert/alertSlice'
import { UI_PERMISSION } from '@/core/utils/access/permissionConstants'
import usePermissions from './userPermission'
import { useAppSelector } from '@/core/app/hooks'
import { RootState } from '@/core/app/store'

interface ClinicalSettingsData {
  [key: string]: any
}

export const useClinicalSettingsUpdate = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { hasAny } = usePermissions()
  const { clinicalSettings } = useAppSelector(
    (state: RootState) => state.userService,
  )

  const showErrorAlert = useCallback((message: string) => {
    dispatch(setAlert({
      message,
      isError: true
    }))
  }, [dispatch])

  const onPrintSettingChange = useCallback((obj: ClinicalSettingsData) => {
    const data = { ...obj }

    if (!hasAny(UI_PERMISSION.UI_PRINT_SETTINGS_CREATE)) {
      showErrorAlert(t("stlPrinting.noPermissionToUpdate"))
      return
    }

    dispatch(updateClinicalSettings(data) as any)
      .then((res: any) => {
        if (res?.payload?.status?.toLowerCase() !== "success") {
          showErrorAlert(t("stlPrinting.dataUpdatedFailure"))
        }
      })
      .catch(() => {
        showErrorAlert(t("stlPrinting.dataUpdatedFailure"))
      })
  }, [
    dispatch,
    hasAny,
    showErrorAlert,
    t
  ])

  return onPrintSettingChange
}